/* eslint no-console: "off" */
import axios from 'axios';
import auth from '@/common/auth';

export default {
  checkIfGameToResumeExists({ commit, rootState }) {
    console.log(`Invoking api/gameToResumeExists?msisdn=${rootState.common.userDetails.msisdn}`);
    return axios({
      method: 'get',
      url: 'api/gameToResumeExists',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      console.log('inside gameToResumeExists');
      const responseData = response.data;
      console.log(responseData);
      if (responseData.responseEnum === 'NO_GAME_EXISTS') {
        console.log('NO_GAME_EXISTS');
        commit('setGameInProgress', false);
      } else if (responseData.responseEnum === 'PENDING_GAME_EXISTS') {
        console.log('PENDING_GAME_EXISTS');
        commit('setGameInProgress', true);
      }
    }).catch((error) => {
      console.log(`Invoking api/gameToResumeExists failed with the following error: ${error}`);
    });
  },
  checkIfGameToResumeExistsForUnauthorizedUsers({ rootState }) {
    console.log(`Invoking api/gameToResumeExistsForUnauthorizedUsers?msisdn=${rootState.common.unauthorizedMsisdn}`);
    return axios({
      method: 'get',
      url: `api/gameToResumeExistsForUnauthorizedUsers?msisdn=${rootState.common.unauthorizedMsisdn}`,
    }).catch((error) => {
      console.log(`Invoking api/checkIfGameToResumeExistsForUnauthorizedUsers failed with the following error: ${error}`);
    });
  },
  awardPrizeAction({ rootState }) {
    console.log('Invoking api/awardPrizeAction');
    return axios({
      method: 'get',
      url: `api/awardPrize?prizeId=${rootState.game.unauthorizedWinnerInfo.prizeId}&code=${rootState.game.unauthorizedWinnerInfo.code}`,
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      console.log(response.data.responseEnum);
    }).catch((error) => {
      console.log(`Invoking api/awardPrizeAction failed with the following error: ${error}`);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/game/actions.js